import { CountryCode } from '@depanneo/types'

export const COUNTRY_CODE_FR = 'FR' as const
export const COUNTRY_NAME_FR = 'France' as const

/**
 * Where a site's address may be (#2334): every `CountryCode`, lowercased for the
 * Places autocomplete (which, unlike the Geocoding API, takes a country list).
 * Module-level, so it is one array identity and adds no effect re-run.
 */
export const SITE_ADDRESS_COUNTRIES = Object.values(CountryCode).map(
  (country) => country.toLowerCase()
)

export const DEFAULT_TIMEZONE = 'Europe/Paris' as const

export const DEFAULT_LOCALE = 'fr-FR' as const

/**
 * Short locale code used in some validation schema default values.
 * Note: DB columns default to 'fr-FR' while some existing schema defaults use 'fr'.
 */
export const DEFAULT_LOCALE_SHORT = 'fr' as const
